import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { I18nProvider } from "@/context/I18nContext";
import Login from "@/pages/Login";
import Workspace from "@/pages/Workspace";
import MonterApp from "@/pages/MonterApp";
import ClientPortal from "@/pages/ClientPortal";
import Presentation from "@/pages/Presentation";
import ObjectInfoPage from "@/pages/ObjectInfoPage";
import UpdateNotifier from "@/components/UpdateNotifier";
import { FP_BUILD } from "@/buildMark";

if (FP_BUILD) document.documentElement.dataset.fpb = FP_BUILD;

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#0F172A] text-slate-400">
        <div className="animate-pulse font-heading text-lg">Ładowanie FiberPass…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="App">
      <I18nProvider>
        <BrandingProvider>
        <AuthProvider>
          <Toaster theme="dark" position="bottom-right" richColors />
          <UpdateNotifier />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/m" element={<MonterApp />} />
              <Route path="/klient" element={<ClientPortal />} />
              <Route path="/prezentacja" element={<Presentation />} />
              <Route path="/o/:module/:id" element={<ObjectInfoPage />} />
              <Route path="/" element={<Protected><SettingsProvider><Workspace /></SettingsProvider></Protected>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
        </BrandingProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
